// @ts-nocheck

import SpecificationTable, {
  TableRowData
} from 'components/tables/SpecificationTable';
import React from 'react';

const processorData: TableRowData[] = [
  {
    key: 'Chip name',
    value: 'Apple M1 chip'
  },
  {
    key: 'Cpu core',
    value: '8 (4 performance and 4 efficiency)'
  },
  {
    key: 'Gpu core',
    value: 7
  },
  {
    key: 'Neural engine',
    value: '16 cores'
  }
];

const storageData: TableRowData[] = [
  {
    key: 'Memory',
    value: '8 GB unified'
  },
  {
    key: 'SSD',
    value: '256 GB'
  }
];

const displayData: TableRowData[] = [
  {
    key: 'Display type',
    value: 'Retina'
  },
  {
    key: 'Size',
    value: '24” (actual diagonal 23.5”)'
  },
  {
    key: 'Resolution',
    value: '4480 x 2520'
  },
  {
    key: 'Brightness',
    value: '500 nits'
  }
];

const additionalData: TableRowData[] = [
  {
    key: 'Camera',
    value: '1080p FaceTime HD camera'
  },
  {
    key: 'Video',
    value: [
      'Full native resolution on built-in display at 1 billion colors;',
      'One external display with up to 6K resolution at 60Hz'
    ]
  },
  {
    key: 'Audio',
    value: [
      'High-fidelity six-speaker with force-cancelling woofers',
      'Wide stereo sound',
      'Spatial audio with Dolby Atmos3',
      'Studio-quality three-mic array with directional beamforming'
    ]
  },
  {
    key: 'Inputs',
    value: ['Magic Keyboard', 'Magic Mouse']
  },
  {
    key: 'Wireless',
    value: [
      '802.11ax Wi-Fi 6 (IEEE 802.11a/b/g/n/ac compatible)',
      'Bluetooth 5.0 wireless technology'
    ]
  },
  {
    key: 'I/O & expantions',
    value: [
      'Thunderbolt / USB 4 ports x 2',
      '3.5 mm headphone jack',
      'Gigabit Ethernet',
      'USB 3 ports x2'
    ]
  },
  {
    key: 'Operating System',
    value: 'macOS Monterey'
  }
];

const ProductSpecificationTables = ({ product }) => {
  const id_ean_usw = [
    {
      key: 'ID',

      value: `${product && `${product.id}`}`
    },
    {
      key: 'Plenty Kategorie ID',

      value: `${
        product &&
        product.datens &&
        product.datens[0] &&
        `${product.datens[0].Plenty_Kategorie_ID}`
      }`
    },
    {
      key: 'Bildnummer',

      value: `${product && `${product.Bildnummer}`}`
    },
    {
      key: 'EAN',

      value: `${product && `${product.EAN}`}`
    },
    {
      key: 'Motiv',

      value: `${product && `${product.Motiv}`}`
    },
    {
      key: 'Eigene SKU',

      value: `${product && `${product.Eigene_SKU}`}`
    },
    {
      key: 'Fotobel SKU',

      value: `${product && `${product.Fotobel_SKU}`}`
    }
  ];

  const varianten = [
    {
      key: 'Anzahl Varianten',

      value: `${product && `${product.Anzahl_Varianten}`}`
    },
    {
      key: 'Variantennummer',

      value: `${product && `${product.Variantennummer}`}`
    },
    {
      key: 'Variantenbezeichnung',

      value: `${product && `${product.Variantenbezeichnung}`}`
    }
  ];

  const eigenschaften = [
    {
      key: 'Motivname',

      value: `${
        product &&
        product.datens &&
        product.datens[0] &&
        `${product.datens[0].Motivname}`
      }`
    },
    {
      key: 'Motivname Count',

      value: `${
        product &&
        product.datens &&
        product.datens[0] &&
        `${product.datens[0].Motivname_Count}`
      }`
    },
    {
      key: 'Number',

      value: `${
        product &&
        product.datens &&
        product.datens[0] &&
        `${product.datens[0].Number}`
      }`
    },
    {
      key: 'Farbe',
      value: `${product && `${product.Farbe}`}`
    }
  ];

  const bezeichnung = [
    {
      key: 'Produktname',
      value: `${
        product &&
        product.ean_gtins &&
        product.ean_gtins[0] &&
        `${product.ean_gtins[0].Produktname}`
      }`
    },
    {
      key: 'Name EAN',
      value: `${
        product &&
        product.datens &&
        product.datens[0] &&
        `${product.datens[0].Name_EAN}`
      }`
    },
    {
      key: 'Kaufland',

      value: `${
        product &&
        product.datens &&
        product.datens[0] &&
        `${product.datens[0].Name_Kaufland_DE}`
      }`
    },
    {
      key: 'OTTO',

      value: `${
        product &&
        product.datens &&
        product.datens[0] &&
        `${product.datens[0].Name_OTTO_DE}`
      }`
    },
    {
      key: 'Shopify',

      value: `${
        product &&
        product.datens &&
        product.datens[0] &&
        `${product.datens[0].Name_Shopify}`
      }`
    },
    {
      key: 'Keywords',
      value: `${
        product &&
        product.datens &&
        product.datens[0] &&
        `${product.datens[0].Real_Keywords}`
      }`
    }
  ];

  const infos = [
    {
      key: 'Marke',
      value: `${
        product &&
        product.ean_gtins &&
        product.ean_gtins[0] &&
        `${product.ean_gtins[0].Marke}`
      }`
    },
    {
      key: 'Anzahl',

      value: `${product && `${product.Anzahl_Deutsch}`}`
    },
    {
      key: 'Masseinheit',

      value: `${
        product &&
        product.ean_gtins &&
        product.ean_gtins[0] &&
        `${product.ean_gtins[0].Masseinheit_Nettofuellmenge_1}`
      }`
    },
    {
      key: 'Konsumenten Einheit',

      value: `${
        product &&
        product.ean_gtins &&
        product.ean_gtins[0] &&
        `${product.ean_gtins[0].Konsumenten_Einheit}`
      }`
    },
    {
      key: 'Produktebene',

      value: `${
        product &&
        product.ean_gtins &&
        product.ean_gtins[0] &&
        `${product.ean_gtins[0].Produktebene}`
      }`
    },
    {
      key: 'Online Katalog',

      value: `${
        product &&
        product.ean_gtins &&
        product.ean_gtins[0] &&
        `${product.ean_gtins[0].Veroeffentlichung_im_Online_Katalog}`
      }`
    },
    {
      key: 'GEPIR',

      value: `${
        product &&
        product.ean_gtins &&
        product.ean_gtins[0] &&
        `${product.ean_gtins[0].Veroeffentlichung_in_GEPIR}`
      }`
    },
    {
      key: 'Zielmarkt',

      value: `${
        product &&
        product.ean_gtins &&
        product.ean_gtins[0] &&
        `${product.ean_gtins[0].Zielmarkt_Verkaufsland_1}`
      }`
    },
    {
      key: 'Waehrung',

      value: `${
        product &&
        product.ean_gtins &&
        product.ean_gtins[0] &&
        `${product.ean_gtins[0].Waehrung}`
      }`
    }
  ];

  return (
    <>
      <div className="mb-6">
        <SpecificationTable title="Eindeutige Bezeichner" data={id_ean_usw} />
      </div>

      <div className="mb-6">
        <SpecificationTable title="Varianten" data={varianten} />
      </div>
      <div className="mb-6">
        <SpecificationTable title="Eigenschaften" data={eigenschaften} />
      </div>
      <div className="mb-6">
        <SpecificationTable title="Lager" data={infos} />
      </div>
      <div className="mb-6">
        <SpecificationTable title="Texte" data={bezeichnung} />
      </div>
    </>
  );
};

export default ProductSpecificationTables;
